/**
 * landUtils.js
 * Hulpfuncties voor landcodes, vlaggen en namen.
 * Ondersteunt IOC/MyLaps alpha-3 codes zoals NED, BEL, GER.
 */

// Alpha-3 → alpha-2 (ISO 3166-1) mapping — alleen landen die voorkomen in HRE data
const ALPHA3_TO_ALPHA2 = {
  NED: 'NL',
  BEL: 'BE',
  GER: 'DE',
  GBR: 'GB',
  FRA: 'FR',
  LUX: 'LU',
  USA: 'US',
  AUS: 'AU',
  CAN: 'CA',
  SUI: 'CH',
  AUT: 'AT',
  DEN: 'DK',
  SWE: 'SE',
  NOR: 'NO',
  FIN: 'FI',
  ESP: 'ES',
  ITA: 'IT',
  POR: 'PT',
  POL: 'PL',
  CZE: 'CZ',
};

// Alpha-3 → volledige landnaam in het Nederlands
const LAND_NAMEN = {
  NED: 'Nederland',
  BEL: 'België',
  GER: 'Duitsland',
  GBR: 'Verenigd Koninkrijk',
  FRA: 'Frankrijk',
  LUX: 'Luxemburg',
  USA: 'Verenigde Staten',
  AUS: 'Australië',
  CAN: 'Canada',
  SUI: 'Zwitserland',
  AUT: 'Oostenrijk',
  DEN: 'Denemarken',
  SWE: 'Zweden',
  NOR: 'Noorwegen',
  FIN: 'Finland',
  ESP: 'Spanje',
  ITA: 'Italië',
  POR: 'Portugal',
  POL: 'Polen',
  CZE: 'Tsjechië',
};

/**
 * Zet een alpha-2 landcode om naar een emoji vlag.
 * Werkt via Unicode Regional Indicator Symbols.
 */
function alpha2NaarVlag(alpha2) {
  if (!alpha2 || alpha2.length !== 2) return '';
  const offset = 0x1F1E6 - 65; // 'A' = 65
  return String.fromCodePoint(
    alpha2.toUpperCase().charCodeAt(0) + offset,
    alpha2.toUpperCase().charCodeAt(1) + offset,
  );
}

/**
 * Geeft de emoji vlag voor een alpha-3 landcode (bijv. 'NED' → '🇳🇱').
 * Geeft lege string terug als de code onbekend is.
 */
export function landVlag(landcode) {
  if (!landcode) return '';
  const alpha2 = ALPHA3_TO_ALPHA2[landcode.toUpperCase()];
  if (!alpha2) return '';
  return alpha2NaarVlag(alpha2);
}

/**
 * Geeft de Nederlandse landnaam voor een alpha-3 landcode.
 * Fallback: de code zelf.
 */
export function landNaam(landcode) {
  if (!landcode) return '';
  return LAND_NAMEN[landcode.toUpperCase()] || landcode;
}
